import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Card, Checkbox, App, Tabs, Select, AutoComplete } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import CookieUtil from '@/utils/cookies';
//使用国际化
import { useTranslation } from 'react-i18next';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { emailLogin, googleLogin, getCodeByEmail, getUserProfile, getCodeByPhone, phoneLogin, getUserAccountSuggestions } from '@/api/user';
import { useAppDispatch } from '@/store/hooks';
import { setUserInfo, setToken } from '@/store/slices/userSlice';
import styles from './index.module.scss';
import icon1 from '@/assets/images/谷歌@2x.png';
import icon2 from '@/assets/images/fees book@2x.png';
import icon3 from '@/assets/images/苹果@2x.png';
import icon4 from '@/assets/images/路径 1717@2x.png';
import icon5 from '@/assets/images/路径 1718@2x.png';

interface LoginForm {
  email: string;
  code: string;
}

interface SmsLoginForm {
  phone: string;
  code: string;
}

type Timer = ReturnType<typeof setInterval>;


// 常用区号列表
const countryCodes = [
  { value: '+1', label: '+1 (US)', flag: '🇺🇸' },
  { value: '+86', label: '+86 (CN)', flag: '🇨🇳' },
  { value: '+44', label: '+44 (UK)', flag: '🇬🇧' },
  { value: '+81', label: '+81 (JP)', flag: '🇯🇵' },
  { value: '+82', label: '+82 (KR)', flag: '🇰🇷' },
  { value: '+65', label: '+65 (SG)', flag: '🇸🇬' },
  { value: '+852', label: '+852 (HK)', flag: '🇭🇰' },
  { value: '+853', label: '+853 (MO)', flag: '🇲🇴' },
  { value: '+886', label: '+886 (TW)', flag: '🇹🇼' },
];

const Login: React.FC = () => {
  //国际化对象
  const { t, i18n } = useTranslation();
  const { message } = App.useApp();

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get('redirect') || '/';

  const [form] = Form.useForm();
  const [smsForm] = Form.useForm();

  // 获取登录表单值
  const formValues = Form.useWatch([], form);
  const smsFormValues = Form.useWatch([], smsForm);

  // 登录方式切换状态
  const [loginType, setLoginType] = useState(''); //email sms undefined

  
 
  const dispatch = useAppDispatch();

  //协议选中
  const [checked, setChecked] = useState(false);

  // 验证码倒计时
  const [countdown, setCountdown] = useState(0);

  // 验证码按钮是否禁用表示
  const [isDisabled, setIsDisabled] = useState(false);

  // 验证码倒计时定时器
  const [timer, setTimer] = useState<Timer | null>(null);

  // 短信验证码倒计时
  const [smsCountdown, setSmsCountdown] = useState(0);
  
  // 账号联想
  const [accountOptions, setAccountOptions] = useState<{account: string; type: number}[]>([]);
  const searchTimerRef = useRef<number | null>(null);
  const [accountUnknown, setAccountUnknown] = useState(false);
  
  // 基础的邮箱/手机号判断
  const isEmail = (val: string) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(val);
  const isPhone = (val: string) => /^[+]?\d[\d\s-]{5,}$/.test(val.trim());

  // 搜索事件
  const handleSearchAccount = (value: string) => {
    // 最小长度限制
    if (!value || value.trim().length < 2) {
      setAccountOptions([]);
      setAccountUnknown(false);
      return;
    }
    // 输入的时候先过滤一遍
    if (isEmail(value)) {
      setLoginType('email');
      setAccountUnknown(false);
    } else if (isPhone(value)) {
      setLoginType('sms');
      setAccountUnknown(false);
    } else {
      setLoginType('');
      setAccountUnknown(true);
    }

    
    // 防抖
    if (searchTimerRef.current) {
      window.clearTimeout(searchTimerRef.current);
    }
    searchTimerRef.current = window.setTimeout(async () => {
      try {
        const res: any = await getUserAccountSuggestions({ query: value.trim() });
        if (res && res.code === 200) {
          const list = res.data || [];
          setAccountOptions(list);
         
        }
      } catch (e) {
        // 忽略错误，只清空选项
        setAccountOptions([]);
        setAccountUnknown(true);
      }
    }, 300);
  };


  const handleSelectAccount = (value: string, option: any) => {
    // 写入表单值
    form.setFieldsValue({ email: value });
    debugger;
    // 设置 loginType：1 手机，2 邮箱
    if (option && typeof option.type === 'number') {
      setAccountUnknown(false);
      setLoginType(option.type === 1 ? 'sms' : 'email');
    }
  };
  const [smsDisabled, setSmsDisabled] = useState(false);
  const [smsTimer, setSmsTimer] = useState<Timer | null>(null);

  // 选中的区号
  const [countryCode, setCountryCode] = useState('+1');

  //发送邮箱验证码或者短信验证码
  const sendAction = ()=>{
    if (loginType === 'email') {
      handleSendCode();
    } else if (loginType === 'sms') {
      handleSendSmsCode();
    }
  }


  //发送邮箱验证码
  const handleSendCode = () => {
    const { email } = formValues;
    if (!email || (!isEmail(email) && !isPhone(email))) {
      message.error(t('common.emailOrPhoneHelp'));
      return;
    }
    // 兜底纠正 loginType
    setLoginType(isPhone(email) ? 'sms' : 'email');

    setIsDisabled(true);

    getCodeByEmail({ email }).then((res: any) => {
      setIsDisabled(false);
      //console.log(res, 'emailemailemailemailemail');
      if (res.code === 200) {

        message.success(t('login.sendSuccess'));
        if (countdown > 0) return;
        // 这里可以加发送验证码的接口调用
        setCountdown(60);
        const t1 = setInterval(() => {
          setCountdown(prev => prev - 1);
        }, 1000);
        setTimer(t1);

      } else {
        message.error(res.message);
      }


    }).catch(err => {
      setIsDisabled(false);
      console.log(err, 'err');
    });

  };

  // 发送手机验证码
  const handleSendSmsCode = () => {
    const { email:phone } = formValues;
    if (!phone || (!isEmail(phone) && !isPhone(phone))) {
      message.error(t('common.emailOrPhoneHelp'));
      return;
    }
    // 兜底纠正 loginType
    setLoginType(isPhone(phone) ? 'sms' : 'email');

    setSmsDisabled(true);

    getCodeByPhone({
      phone: phone
    }).then((res: any) => {
      setSmsDisabled(false);
      console.log(res, 'sms code response');
      if (res.code === 200) {
        message.success(t('login.sendSuccess'));
        if (smsCountdown > 0) return;

        setSmsCountdown(60);
        const t1 = setInterval(() => {
          setSmsCountdown(prev => prev - 1);
        }, 1000);
        setSmsTimer(t1);
      } else {
        message.error(res.message);
      }
    }).catch(err => {
      setSmsDisabled(false);
      console.log(err, 'sms error');
    });
  };

  //谷歌登录成功处理
  const handleGoogleSuccess = async (credentialResponse: any) => {

    try {
      console.log('Google登录成功:', credentialResponse);

      // 将Google的credential发送到后端进行验证
      const res: any = await googleLogin({ token_data: credentialResponse.credential });

      if (res.code === 200) {
        CookieUtil.set('token', res.data.token, { expires: 7 });
        CookieUtil.set('userInfo', res.data.user, { expires: 7 });

        dispatch(setToken(res.data.token));
        dispatch(setUserInfo(res.data.user));

        message.success(t('login.success'));
        navigate(redirect);

      } else {
        message.error(res.message);
      }

    } catch (error: any) {
      console.error('Google login failed:', error);
      message.error(t('login.googleloginError'));
    }
  };

  //谷歌登录失败处理
  const handleGoogleError = () => {
    //debugger
    message.error(t('login.googleloginError'));
  };


  const changeCheck = (e: any) => {

    setChecked(e.target.checked);

    if (e.target.checked) {
      localStorage.setItem('loginCheck', 'true');
    }

  };

  //邮箱验证码登录逻辑
  const onFinish = async (values: LoginForm) => {

    if (!checked) {
      message.error(t("login.readAagree"));
      return;
    }
    try {
      // 提交前兜底推断一次
      const inferred = isPhone(values.email) ? 'sms' : (isEmail(values.email) ? 'email' : null);
      if (!inferred) {
        message.error(t('common.emailOrPhoneHelp'));
        return;
      }

      const loginAction = inferred === 'email' ? emailLogin : phoneLogin;
      const params:any = inferred === 'email'
        ? { email: values.email, code: values.code }
        : { phone: values.email, code: values.code };

      const res: any = await loginAction(params);

      if (res.code === 200) {
        CookieUtil.set('token', res.data.token, { expires: 7 });
        dispatch(setToken(res.data.token));

        getUserProfile().then((res2: any) => {
          if (res2.code === 200) {

            res2.data.emergency_service_member = false;
            res2.data.carpool_service_member = false;

            res2?.data.vip_info?.forEach((item: any) => {
              // 紧急服务会员
              if (item.vip_type === 0) {
                res2.data.emergency_service_member = true;
                //拼车订单会员
              } else if (item.vip_type === 1) {
                res2.data.carpool_service_member = true;
              }
            });


            const tokenInfo = res2.data;
            let locationHref = localStorage.getItem('locationHref');
            CookieUtil.set('userInfo', tokenInfo, { expires: 7 });
            dispatch(setUserInfo(tokenInfo));
            message.success(t('login.success'));
            if(locationHref){
              navigate(locationHref);
              localStorage.removeItem('locationHref');
              return
            }
            navigate(redirect);
            
          }
        });

      } else {
        message.error(res.message);
      }

      // 使用 Redux 存储用户信息

      // 显示成功消息

    } catch (error: any) {
      console.error('登录失败:', error);

    }
  };

  // 手机验证码登录逻辑
  const onSmsFinish = async (values: SmsLoginForm) => {
      if (!checked) {
      message.error(t('login.readAagree'));
      return;
    }

    try {
      const res: any = await phoneLogin({
        phone: countryCode + values.phone,
        code: values.code
      });

      if (res.code === 200) {
        CookieUtil.set('token', res.data.token, { expires: 7 });
        dispatch(setToken(res.data.token));

        getUserProfile().then((res2: any) => {
          if (res2.code === 200) {
            res2.data.emergency_service_member = false;
            res2.data.carpool_service_member = false;

            res2?.data.vip_info?.forEach((item: any) => {
              if (item.vip_type === 0) {
                res2.data.emergency_service_member = true;
              } else if (item.vip_type === 1) {
                res2.data.carpool_service_member = true;
              }
            });

            const tokenInfo = res2.data;
            CookieUtil.set('userInfo', tokenInfo, { expires: 7 });
            dispatch(setUserInfo(tokenInfo));

            message.success(t('login.success'));
            navigate(redirect);
          }
        });      } else {
        message.error(res.message);
      }

    } catch (error: any) {
      console.error('手机登录失败:', error);
    }
  };

  //清空定时器逻辑
  useEffect(() => {
    if (countdown === 0 && timer) {
      clearInterval(timer);
      setTimer(null);
    }
  }, [countdown, timer]);

  // 清空SMS定时器逻辑
  useEffect(() => {
    if (smsCountdown === 0 && smsTimer) {
      clearInterval(smsTimer);
      setSmsTimer(null);
    }
  }, [smsCountdown, smsTimer]);

  // 检查是否已登录,如果登录直接回首页
  useEffect(() => {
    const token = CookieUtil.get('token');
    const userInfo = CookieUtil.get('userInfo');

    if (token && userInfo) {
      dispatch(setToken(token));
      dispatch(setUserInfo(userInfo));
      navigate(redirect);
    }

    if (!!localStorage.getItem('loginCheck')) {
      setChecked(true);
    }
  }, []);

  return (
    <div className={styles['login-container']}>
    {/* loginType  {loginType}
    <br></br>
    accountUnknown  {accountUnknown+''} */}
      <div className={styles['login-card']}>
        {/* 登录方式切换 */}
        {/* <Tabs
          activeKey={loginType}
          onChange={setLoginType}
          className={styles['login-tabs']}
          items={[
            {
              key: 'email',
              label: t('login.emailLogin'),
            },
            {
              key: 'sms',
              label: t('login.mobileLogin'),
            },
          ]}
        /> */}

        <div className={styles['login-title']}> {t('login.loginVidfi')}</div>
        <div className={styles['login-desc']}>{t('login.welcome')}</div>



        {/* 邮箱登录表单 */}
        {/* {loginType === 'email' && (
          
        )} */}

        <Form
          form={form}
          name="login"
          className={styles['login-form']}
          onFinish={onFinish}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: t('emailOrPhonePl') }]}
            help={accountUnknown ? t('common.emailOrPhoneHelp') : undefined}
            validateStatus={accountUnknown ? 'error' : undefined}
          >
            <AutoComplete
              placeholder={t('common.EmailOrPhone')}
              size="large"
              options={(accountOptions || []).map(item => ({
                value: item.account,
                label: item.account,
                type: item.type,
              }))}
              onSearch={handleSearchAccount}
              onSelect={handleSelectAccount}
              filterOption={false}
            />
          </Form.Item>
          <div className={styles['login-code-row']}>
            <Form.Item
              name="code"
              rules={[{ required: true, message: t('common.codePl') }]}
              className={styles['login-code-input']}
            >
              <Input placeholder={t('common.code')} size="large" />
            </Form.Item>
            <Button
              className={styles['login-send-btn']}
              size="large"
              loading={isDisabled}
              disabled={countdown > 0 || accountUnknown}
              onClick={sendAction}
            >{countdown > 0 ? `${countdown}s` : t('common.send')}</Button>
          </div>
          <Form.Item>
            <Button type="primary" htmlType="submit" className={styles['login-button']} size="large">
              {t('login.title')}
            </Button>
          </Form.Item>
        </Form>

          {/* 手机登录表单 */}
        {/* {loginType === 'sms' && (
          <Form
            form={smsForm}
            name="smsLogin"
            className={styles['login-form']}
            onFinish={onSmsFinish}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="phone"
              rules={[{ required: true, message: t('login.phonePl') }]}
            >
              <Input
                addonBefore={
                  <Select
                    value={countryCode}
                    onChange={setCountryCode}
                    style={{ width: 120 }}
                    showSearch
                    optionFilterProp="label"
                  >
                    {countryCodes.map(country => (
                      <Select.Option key={country.value} value={country.value} label={country.label}>
                        <span style={{ marginRight: 8 }}>{country.flag}</span>
                        {country.label}
                      </Select.Option>
                    ))}
                  </Select>
                }
                placeholder={t('login.mobilePlaceholder')}
                size="large"
              />
            </Form.Item>
            <div className={styles['login-code-row']}>
              <Form.Item
                name="code"
                rules={[{ required: true, message: t('login.inputVerificationCode') }]}
                className={styles['login-code-input']}
              >
                <Input placeholder={t('common.code')} size="large" />
              </Form.Item>
              <Button
                className={styles['login-send-btn']}
                size="large"
                loading={smsDisabled}
                disabled={smsCountdown > 0}
                onClick={handleSendSmsCode}
              >{smsCountdown > 0 ? `${smsCountdown}s` : t('common.send')}</Button>
            </div>
            <Form.Item>
              <Button type="primary" htmlType="submit" className={styles['login-button']} size="large">
                {t('login.logon')}
              </Button>
            </Form.Item>
          </Form>
        )} */}        
        <div className={styles['login-agreement']}>
          <Checkbox
            checked={checked}
            onChange={changeCheck}
            style={{ marginRight: 5 }}
          ></Checkbox>
          <span>
            {t('login.haveAndagree')}
            <a>《{t('login.townlooppsa')}》</a>
             {t('login.andThe')}
             <a href='/privacyPolicy'>《{t('login.PrivacyPolicy')}》</a>
          </span>
        </div>
        {/* {
          !!checked && (
           
          )
        } */}



        <div className={styles['login-safe']}> 

          <div className={styles['login-safe-title']}>
            <img src={icon4} />
            <span className={styles['login-safe-green']}>{t('login.temuCard')}</span>
          </div>
          <div className={styles['login-safe-desc']}>
            <div>
              <img src={icon5} />
              <span>{t('login.tempfllow')}</span>
            </div>
          </div>
          <div className={styles['register-btn']}>
            <div className={styles['or-signin-text']}>
              <span className={styles['or-line']}></span>
              <span className={styles['or-text']}>{t('login.orSignWith')}</span>
              <span className={styles['or-line']}></span>
            </div>
            {
              !!checked && (
                <div className={styles['login-social-row']}>
                  {/* 谷歌登录 */}
                  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
                    <div className={styles['google-login-container']}>
                      <GoogleLogin
                        locale={i18n.language}
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        useOneTap
                        theme="outline"
                        size="large"
                        text="signin_with"
                        shape="rectangular"
                        logo_alignment="left"
                        width="40px"
                        containerProps={{
                          className: "google-login-button"
                        }}
                      />
                    </div>
                  </GoogleOAuthProvider>

                  {/* <img src={icon2} alt="Facebook" /> */}
                  {/* <img src={icon3} alt="Apple" /> */}
                </div>
              )
            }

            <div className={styles['bottom-links']}>
              <a
                href="#"
                className={styles['register-link']}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/register');
                }}
              >
                {t('login.register')}
              </a>
              <span className={styles['divider']}>|</span>
              <a
                href="#"
                className={styles['forgot-link']}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/forgotpassword');
                }}
              >
                {t('login.forgetPassword')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 